import { SideImage } from '../../components/SideImage';
import { StickyFooter } from '../../components/StickyFooter';
import { SpaDaysBookingContent } from '../../composites/SpaDaysBookingContent';
import { SplitLayout } from '../../composites/SplitLayout';
import { HideOnMobile } from './SpaDaysBookingForm.styles';
import type { SpaDaysBookingFormProps } from './SpaDaysBookingForm.types';

export function SpaDaysBookingForm({
  imageUrl,
  imageAlt,
  onBack,
  stickyFooter,
  ...contentProps
}: SpaDaysBookingFormProps) {
  return (
    <SplitLayout
      left={
        <HideOnMobile>
          <SideImage src={imageUrl} alt={imageAlt} sticky onBack={onBack} />
        </HideOnMobile>
      }
      right={
        <>
          <SpaDaysBookingContent {...contentProps} />
          {stickyFooter && <StickyFooter {...stickyFooter} />}
        </>
      }
      contentGap="0px"
      contentMaxWidth="100%"
    />
  );
}
